/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown> }} Explorer_Info_Batch_Error_No_GroupsInputs */



/**
* | output |
* | --- |
* | "{project}: no valid event groups" |
*
* @param {Explorer_Info_Batch_Error_No_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_error_no_groups = /** @type {((inputs: Explorer_Info_Batch_Error_No_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Error_No_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.project}: aucun groupe d'événements valide`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.project}: Keine gültigen Ereignisgruppen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.project}: nessun gruppo di eventi valido`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.project}: отсутствуют действительные группы событий`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.project}: no hay grupos de eventos válidos`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.project}：没有有效的事件组`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.project}: 有効なイベントグループがありません`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.project}: कोई वैध इवेंट समूह नहीं`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.project}: nenhum grupo de eventos válido`)
	return /** @type {LocalizedString} */ (`${i?.project}: no valid event groups`)
});